import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import Accounts from './pages/Accounts.vue';
import Templates from './pages/Templates.vue';
import AccountProfile from './pages/AccountProfile.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/whatsapp'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'settings_whatsapp_accounts',
          meta: {
            permissions: ['administrator', 'manager'],
          },
          component: Accounts,
        },
        {
          path: 'templates',
          name: 'settings_whatsapp_templates',
          meta: {
            permissions: ['administrator', 'manager'],
          },
          component: Templates,
        },
        // Deprecated: Category selection page removed - category is now selected within the create page
        // {
        //   path: 'templates/category',
        //   name: 'settings_whatsapp_template_category',
        //   meta: {
        //     permissions: ['administrator'],
        //   },
        //   component: () => import('./pages/TemplateCategorySelection.vue'),
        // },
        {
          path: 'templates/create',
          name: 'settings_whatsapp_template_create',
          meta: {
            permissions: ['administrator', 'manager'],
          },
          component: () => import('./pages/TemplateCreate.vue'),
        },
        {
          path: 'templates/:templateId/edit',
          name: 'settings_whatsapp_template_edit',
          meta: {
            permissions: ['administrator', 'manager'],
          },
          component: () => import('./pages/TemplateEdit.vue'),
        },
        {
          path: 'account/:inboxId/profile',
          name: 'settings_whatsapp_account_profile',
          meta: {
            permissions: ['administrator', 'manager'],
          },
          component: AccountProfile,
        },
      ],
    },
  ],
};
